import axios from './BaseService';

const NEWS_URL = `${process.env.REACT_APP_API_URL}/news`;

export async function getNews(limit = 50, coin) {
    const params = new URLSearchParams({ limit: String(limit) });
    if (coin) params.set('coin', coin);
    const response = await axios.get(`${NEWS_URL}?${params.toString()}`);
    return response.data;
}

export async function getSources() {
    const response = await axios.get(`${NEWS_URL}/sources`);
    return response.data;
}

export async function addSource(name, url, type) {
    const response = await axios.post(`${NEWS_URL}/sources`, { name, url, type });
    return response.data;
}

export async function updateSource(id, patch) {
    const response = await axios.patch(`${NEWS_URL}/sources/${id}`, patch);
    return response.data;
}

export async function deleteSource(id) {
    const response = await axios.delete(`${NEWS_URL}/sources/${id}`);
    return response.data;
}
